import React from "react";
var __jsx = React.createElement;
import { useState, useEffect } from "react";
import SavedSearchTag from "@/pages/saved-search/components/SavedSearchTag";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import { useLang } from "@/common/Contexts/LanguageContext";
import useIsMobile from "@hooks/useIsMobile";
import { TAG_TYPES } from "../saved-search";
var SavedSearchTagContainer = function SavedSearchTagContainer(_ref) {
  var tags = _ref.tags,
    _ref$isEditing = _ref.isEditing,
    isEditing = _ref$isEditing === void 0 ? false : _ref$isEditing,
    onDeleteTag = _ref.onDeleteTag;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    isExpanded = _useState[0],
    setIsExpanded = _useState[1];
  var lang = useLang();
  var isMobile = useIsMobile();
  var _useState2 = useState(4),
    maxVisibleTags = _useState2[0],
    setMaxVisibleTags = _useState2[1];
  useEffect(function () {
    setMaxVisibleTags(isMobile ? 5 : 12);
  }, [isMobile]);
  var toggleExpand = function toggleExpand() {
    return setIsExpanded(!isExpanded);
  };
  var visibleTags = isEditing ? tags : isExpanded ? tags : tags === null || tags === void 0 ? void 0 : tags.slice(0, maxVisibleTags);
  var getTagTitle = function getTagTitle(tag) {
    if (tag.type === TAG_TYPES.RANGE) {
      if (lang === 'ar') {
        var _tag$range_values;
        return "".concat(tag.range_values.from, " - ").concat(tag.range_values.to, " ").concat(tag === null || tag === void 0 ? void 0 : (_tag$range_values = tag.range_values) === null || _tag$range_values === void 0 ? void 0 : _tag$range_values.unit_ar, " ");
      } else {
        var _tag$range_values2;
        return "".concat(tag.range_values.from, " - ").concat(tag.range_values.to, " ").concat(tag === null || tag === void 0 ? void 0 : (_tag$range_values2 = tag.range_values) === null || _tag$range_values2 === void 0 ? void 0 : _tag$range_values2.unit_en);
      }
    } else {
      return lang === 'ar' ? tag.name_ar : tag.name_en;
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap gap-2"
  }, visibleTags === null || visibleTags === void 0 ? void 0 : visibleTags.map(function (tag, index) {
    return /*#__PURE__*/React.createElement(SavedSearchTag, {
      key: (tag === null || tag === void 0 ? void 0 : tag.id) || "saved-search-tag-".concat(index),
      title: getTagTitle(tag),
      onDelete: function onDelete() {
        return onDeleteTag && onDeleteTag(tag.uuid);
      },
      haveDelete: isEditing && (tags === null || tags === void 0 ? void 0 : tags.length) > 1
    });
  }), !isEditing && (tags === null || tags === void 0 ? void 0 : tags.length) > maxVisibleTags && /*#__PURE__*/React.createElement("span", {
    onClick: toggleExpand,
    className: "text-primary font-semibold text-sm cursor-pointer p-2"
  }, isExpanded ? /*#__PURE__*/React.createElement("span", {
    className: "flex gap-2 align-center underline"
  }, t("view_less", {
    ns: "saved_search"
  }), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/minus-circle-primary.svg",
    alt: "expand"
  })) : /*#__PURE__*/React.createElement("span", {
    className: "flex gap-0.5 underline"
  }, t("view_2", {
    ns: "saved_search"
  }), /*#__PURE__*/React.createElement("span", {
    className: "flex align-center gap-2"
  }, "(".concat(tags.length - maxVisibleTags, ")"), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/add-circle-pirmary.svg",
    alt: "expand"
  }))))));
};
export default SavedSearchTagContainer;